// extracted by mini-css-extract-plugin
export default {"sider":"sidebar_sider__qkqTJ","footer":"sidebar_footer__ua64j","logout":"sidebar_logout__eD7UW","menu":"sidebar_menu__zhNtc"};